import microphoneIcon from "./assets/icons/microphone.svg?inline";
import microphoneIconRaw from "./assets/icons/microphone.svg?raw";
import restartIcon from "./assets/icons/restart.svg?inline";
import restartIconRaw from "./assets/icons/restart.svg?raw";
import closeIcon from "./assets/icons/close.svg?inline";
import closeIconRaw from "./assets/icons/close.svg?raw";
import stopIcon from "./assets/icons/stop.svg?inline";
import stopIconRaw from "./assets/icons/stop.svg?raw";
import arrowPathIconRaw from "./assets/icons/arrow-path.svg?raw";
import commandLineIconRaw from "./assets/icons/command-line.svg?raw";
import cursorArrowRaysIconRaw from "./assets/icons/cursor-arrow-rays.svg?raw";
import faceSmileIconRaw from "./assets/icons/face-smile.svg?raw";
import handRaisedIconRaw from "./assets/icons/hand-raised.svg?raw";
import mapIconRaw from "./assets/icons/map.svg?raw";
import microphoneOutlineIconRaw from "./assets/icons/microphone-outline.svg?raw";
import queueListIconRaw from "./assets/icons/queue-list.svg?raw";
import stopOutlineIconRaw from "./assets/icons/stop-outline.svg?raw";
import xMarkIconRaw from "./assets/icons/x-mark.svg?raw";
import bulutLogo from "./assets/icons/bulut_logo.svg";
import bulutLogoRaw from "./assets/icons/bulut_logo.svg?raw";
import sentSfx from "./assets/sfx/sent.mp3";
import thinkingSfx from "./assets/sfx/thinking.mp3";
import toolCallSfx from "./assets/sfx/tool_call.mp3";
import completedSfx from "./assets/sfx/completed.mp3";

export const microphoneIconUrl = microphoneIcon;
export const microphoneIconContent = microphoneIconRaw;
export const restartIconUrl = restartIcon;
export const restartIconContent = restartIconRaw;
export const closeIconUrl = closeIcon;
export const closeIconContent = closeIconRaw;
export const stopIconUrl = stopIcon;
export const stopIconContent = stopIconRaw;
export const arrowPathIconContent = arrowPathIconRaw;
export const commandLineIconContent = commandLineIconRaw;
export const cursorArrowRaysIconContent = cursorArrowRaysIconRaw;
export const faceSmileIconContent = faceSmileIconRaw;
export const handRaisedIconContent = handRaisedIconRaw;
export const mapIconContent = mapIconRaw;
export const microphoneOutlineIconContent = microphoneOutlineIconRaw;
export const queueListIconContent = queueListIconRaw;
export const stopOutlineIconContent = stopOutlineIconRaw;
export const xMarkIconContent = xMarkIconRaw;
export const logoUrl = bulutLogo;
export const logoContent = bulutLogoRaw;
export const sentSfxUrl = sentSfx;
export const thinkingSfxUrl = thinkingSfx;
export const toolCallSfxUrl = toolCallSfx;
export const completedSfxUrl = completedSfx;
